var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.route.history.current.path!='/login')?_c('SidebarMenu'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('FooterBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }